import { render, staticRenderFns } from "./SmsRedemption.vue?vue&type=template&id=50380f42"
import script from "./SmsRedemption.vue?vue&type=script&lang=js"
export * from "./SmsRedemption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports